import React from "react";

class SessionTimeout extends React.Component {
  inactivityTimeout = null;

  componentDidMount() {
    this.resetTimer();
    this.addListeners();
  }

  componentWillUnmount() {
    this.clearTimer();
    this.removeListeners();
  }

  clearTimer = () => {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
  };

  resetTimer = () => {
    this.clearTimer();
    this.inactivityTimeout = setTimeout(() => {
      window.location.href = "/Logout";
    }, 15 * 60 * 1000); //15 mins
  };

  addListeners = () => {
    const events = ["mousemove", "mousedown", "keydown", "click", "scroll", "touchstart", "touchmove", "wheel"];
    events.forEach((event) =>
      document.addEventListener(event, this.resetTimer)
    );
  };

  removeListeners = () => {
    const events = ["mousemove", "mousedown", "keydown", "click", "scroll", "touchstart", "touchmove", "wheel"];
    events.forEach((event) =>
      document.removeEventListener(event, this.resetTimer)
    );
  };

  render() {
    return this.props.children;
  }
}

export default SessionTimeout;
